var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSquareFour = function SvgIconNumberSquareFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.958 6.182a1 1 0 0 1 .61 1.276l-1.78 5.042h2.087v-2a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0v-2h-3.5a1 1 0 0 1-.943-1.333l2.25-6.375a1 1 0 0 1 1.276-.61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zm.25 16.5V4.75h14.5v14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconNumberSquareFour;